import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PolicyPage.css';

function TermsOfServicePage() {
  const navigate = useNavigate();

  return (
    <div className="policy-page">
      <div className="policy-container">
        <button
          onClick={() => navigate('/')}
          className="back-button"
        >
          ← 返回首頁
        </button>

        <h1 className="policy-title">Terms of Service 服務條款</h1>

        <div className="policy-content">
          <h2>Terms of Service</h2>

          <h3>1. Scope of Use</h3>
          <p>Users may access and use the platform's services in accordance with these terms.</p>
          <p>Any illegal, infringing, or disruptive activities are strictly prohibited.</p>
          <p>Users shall not commercialize, resell, reproduce, or otherwise use the platform's content or tools without authorization.</p>
          <p>The platform reserves the right to suspend services or pursue legal action if violations occur.</p>

          <h3>2. Disclaimer</h3>
          <p>The platform does not guarantee timeliness, accuracy, completeness, or uninterrupted service.</p>
          <p>It shall not be liable for damages arising from service interruptions, technical failures, or data loss.</p>
          <p>The platform only provides technical services and assumes no liability for legal disputes arising from user-generated content (including copyright, trademark, or reputation issues).</p>

          <h3>3. Privacy Policy</h3>
          <p>User personal data will be collected and processed in accordance with the Privacy Policy.</p>
          <p>Please refer to the full Privacy Policy for details.</p>

          <h3>4. Intellectual Property</h3>
          <p>All platform systems, trademarks, works, code, and related technologies are owned by the platform or their rightful owners.</p>
          <p>User-generated or uploaded content is limited to in-platform use only. Redistribution, resale, sharing, or publishing on external platforms is prohibited.</p>
          <p>Unauthorized use, modification, distribution, or reproduction of any content is forbidden.</p>

          <h3>5. Content Review</h3>
          <p>All user-submitted content will be subject to manual review before publication.</p>
          <p>The platform reserves the right to reject, withhold, or remove content that violates its standards.</p>

          <h3>6. Termination</h3>
          <p>The platform may suspend or terminate user access in case of violations.</p>
          <p>Users may be held liable for damages resulting from breaches of these terms.</p>

          <h3>7. Dispute Resolution</h3>
          <p>Any disputes arising from these terms or services shall first be resolved through negotiation.</p>
          <p>If unresolved, both parties agree that the court located in the platform's jurisdiction shall have exclusive jurisdiction, and the governing law shall be the laws of Taiwan (R.O.C.).</p>

          <hr style={{ margin: '3rem 0', border: 'none', borderTop: '2px solid #e2e8f0' }} />

          <h2>服務條款</h2>

          <h3>一、使用範圍</h3>
          <p>用戶可透過本平台依照規範使用服務。</p>
          <p>禁止任何違反法律、侵害他人權益或違反公共秩序之行為。</p>
          <p>用戶不得將本平台提供之內容或工具用於商業化、轉售、轉載或其他未經授權之使用。</p>
          <p>若用戶違反規範，本平台有權立即停止服務並依法追究責任。</p>

          <h3>二、免責聲明</h3>
          <p>本平台不保證服務的即時性、正確性、完整性或不中斷。</p>
          <p>因服務中斷、技術故障、資料遺失等造成的損害，本平台不負賠償責任。</p>
          <p>本平台僅提供技術服務，對於用戶所產生或發表的內容所引發的衍生法律責任（例如著作權、名譽權等侵權糾紛），本平台不承擔任何責任。</p>

          <h3>三、隱私權政策</h3>
          <p>用戶個人資料將依照《隱私權政策》處理與保護。</p>
          <p>詳細內容請參閱平台提供之《隱私權政策》。</p>

          <h3>四、智慧財產權</h3>
          <p>平台系統、商標、著作、程式碼及相關技術均屬本平台或合法權利人所有。</p>
          <p>用戶於平台所產生或上傳之內容，僅限於平台內部使用，禁止轉載、轉售、提供給第三人或於其他平台公開。</p>
          <p>未經授權，任何人不得擅自使用、修改、散布或複製。</p>

          <h3>五、內容審核機制</h3>
          <p>所有用戶發表的內容，將由人工審核後才會公開發布。</p>
          <p>平台保留拒絕、不公開或刪除不符合規範內容之權利。</p>

          <h3>六、終止條款</h3>
          <p>若用戶違反本條款，平台有權暫停或終止使用權限。</p>
          <p>因違約造成的損害，平台得依法向用戶請求賠償。</p>

          <h3>七、爭議解決</h3>
          <p>若因本條款或服務引發爭議，雙方應先協商解決。</p>
          <p>如協商不成，雙方同意以平台所在地法院為第一審管轄法院，並適用中華民國法律。</p>
        </div>

        <div className="policy-footer">
          <p>最後更新日期：{new Date().toLocaleDateString('zh-TW')}</p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
